import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { UserProfileEffects } from './user-profile.effects';
import { initialState, reducer } from './user-profile.reducer';
import { createLocalStorageSyncReducer } from '../local-storage-sync';
import { UserProfileState } from './user-profile.state';
import { getEnvironment } from '../../features/shared/utils/get-environment';

const syncMetaReducer = createLocalStorageSyncReducer<UserProfileState>({
  keys: ['theme', 'useNextTheme'],
  rehydrate: true,
  storage: localStorage,
  storageKeySerializer: (key) => `semeris-${getEnvironment()}-${key}`,
});

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('userProfile', reducer, {
      initialState,
      metaReducers: [syncMetaReducer],
    }),
    EffectsModule.forFeature([UserProfileEffects]),
  ],
  providers: [UserProfileEffects],
})
export class UserProfileStoreModule {}
